// @need-translate
import {AppLinkFallbackType} from '../applink/AppLinkFallbackType.enum';
import {pagewebUrlMatcher} from '../applink/PagewebUrlMatcher.singleton';
import {axiosBffFetch} from '../axios/axiosBffFetch';
import {t} from '../common/getTranslations';
import {requestContext} from '../common/requestContext';
import {showSimpleDialog} from '../dialog/simpleDialogHandler';
import {kakaoLogin, LoginHandlerParam} from '../domain/login/util/kakaoLogin';
import {commonErrorHandler} from '../errors/commonErrorHandler';
import {getSerializedPagewebError} from '../errors/getSerializedPagewebError.function';
import {PagewebError} from '../errors/PagewebError.class';
import {PagewebErrorType} from '../errors/PagewebErrorType.enum';

export function handleLoginPageweb(params?: Partial<LoginHandlerParam>) {
  const {callbackUrl = window.location.href, relayPagePath = '/relay/login'} =
    params || {};
  const {isKakaotalk, isMobile} = requestContext.requestInfo.display;
  if (isKakaotalk) {
    showSimpleDialog({
      title: '카카오페이지 앱에서 로그인 후 더 많은 작품을 만나보세요.',
      cancelButton: {
        type: 'label',
        text: t('common_close_button'),
      },
      okButton: {
        type: 'label',
        text: '카카오페이지 앱 열기',
        onClick: () => {
          const appLinkUrl = pagewebUrlMatcher.getDefaultAppLink({
            schemePrefixType: 'applink',
            fallbackType: AppLinkFallbackType.Store,
          });
          window.location.assign(appLinkUrl);
        },
      },
      isMobile,
    });
    return;
  }

  axiosBffFetch('/api/prepare_login', {
    method: 'POST',
    withCredentials: true,
  })
    .then(() => kakaoLogin({callbackUrl, relayPagePath}))
    .catch(handleLoginError);
}

function handleLoginError(error: Error) {
  if (error.message === 'Network Error') {
    showSimpleDialog({
      isMobile: requestContext.requestInfo.display.isMobile,
      title: t('error_network_title'),
      description: t('error_network_connect_check'),
      cancelButton: {
        type: 'label',
        text: t('common_close_button'),
      },
    });
  } else {
    const serializedPagewebError = getSerializedPagewebError(
      new PagewebError({
        isSerializedPagewebError: true,
        type: PagewebErrorType.UnknownError,
        message: error.message,
      })
    );
    commonErrorHandler(serializedPagewebError);
  }
}
